import { TenantIdParamSchema } from '../../schemas/params.js';
import { ConfigureSsoRequestSchema, ConfigureSsoResponseSchema, DisableSsoResponseSchema, SsoLoginRequestSchema, SsoLoginResponseSchema, SsoTestConnectionResponseSchema, } from '../../schemas/sso.schemas.js';
/** REST contract for `insight-api/src/routes/sso.routes.ts`. */
export const ssoContract = {
    configure: {
        method: 'POST',
        path: '/sso/configure/:tenantId',
        pathParams: TenantIdParamSchema,
        body: ConfigureSsoRequestSchema,
        response: ConfigureSsoResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to configure SSO',
    },
    disable: {
        method: 'DELETE',
        path: '/sso/configure/:tenantId',
        pathParams: TenantIdParamSchema,
        response: DisableSsoResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to disable SSO',
    },
    getLoginUrl: {
        method: 'POST',
        path: '/sso/login',
        body: SsoLoginRequestSchema,
        response: SsoLoginResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get SSO login URL',
    },
    testConnection: {
        method: 'GET',
        path: '/sso/test/:tenantId',
        pathParams: TenantIdParamSchema,
        response: SsoTestConnectionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to test SSO connection',
    },
};
//# sourceMappingURL=sso.contract.js.map